// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if ({"vendors-node_modules_lazysizes_plugins_blur-up_ls_blur-up_js-node_modules_lazysizes_plugins_p-e5baa4":1,"lazysizes":1}[chunkId]) return "" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};